// Replacement for https://lodash.com/docs/4.17.15#uniq
export const uniq = <T>(baseArray: T[]) => {
    return baseArray.filter((value, index, array) => array.indexOf(value) === index);
};
